import { render, staticRenderFns } from "./QuartersField.vue?vue&type=template&id=0fe5ff1a&"
import script from "./QuartersField.vue?vue&type=script&lang=ts&"
export * from "./QuartersField.vue?vue&type=script&lang=ts&"
import style0 from "./QuartersField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports